"use client"

import StatsCard from "../modules/StatsCard/StatsCard"

import styles from "../../../pages/inventory/InventoryDashboardPage.module.css"

const DashboardStats = ({ stats }) => (
  <div className={styles.section}>
    <div className={styles.stats_grid}>
      {stats.map((stat, index) => (
        <StatsCard
          key={index}
          title={stat.title}
          value={stat.value}
          changeType={stat.changeType}
          iconColor={stat.iconColor}
          className={styles.stat_card}
        />
      ))}
    </div>
  </div>
)

export default DashboardStats
